import { render, staticRenderFns } from "./AppRichTextComponent.vue?vue&type=template&id=0642aad7&scoped=true"
import script from "./AppRichTextComponent.vue?vue&type=script&lang=js"
export * from "./AppRichTextComponent.vue?vue&type=script&lang=js"
import style0 from "./AppRichTextComponent.vue?vue&type=style&index=0&id=0642aad7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0642aad7",
  null
  
)

export default component.exports